import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ImageUrlCacheService } from 'src/app/services';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { ToggleSidebarService } from 'src/app/services/toggle-sidebar.service';
import { EntitiesServiceService } from '../../../../services/entities-service.service';
import { TimePeriod } from 'ngx-daterangepicker-material/daterangepicker.component';
@Component({
  selector: 'app-entities-wrapper',
  templateUrl: './entities-wrapper.component.html',
  styleUrls: ['./entities-wrapper.component.css']
})
export class EntitiesWrapperComponent implements OnInit, OnDestroy {

  masterEntitiesData: any;
  entityId: string;
  parentEntityId: string = null;
  widgetDetails: any;
  periodFilterData: number = 1;
  attributeThreshold: any = [];
  tenantType: string = null;
  attributeIcons: any = [];
  refreshRate: any;
  filterLists: any[] = [];
  activeAlertsCount: any;
  dynamicEntityData: any = [];
  startTime: any;
  tenantConfig: any = {};
  toggleDigitalTwin: boolean = false;
  entitiesStatus:{status:string,color:string};
  siteId: string;
  objectKeys = Object.keys;
  expandCheckPointFlag : boolean = false;
  isLoader: boolean = true;

  //Date time range picker
  public datepickerForm: FormGroup;
  selectedDates = {
    from: null,
    to: null,
  };
  private _initializeForm(type: string = 'default') {
    this.datepickerForm = this._fb.group({
      thisdate: null
    });
  }
  datePicker = new FormControl(new Date());

  private _period = new FormControl();
  private _periodList = [{ id: 1, name: 'Today' }, { id: 2, name: 'Last 7 days' }, { id: 3, name: 'Last month' }, { id: 4, name: 'Last 3 months' },
  { id: 5, name: 'Last 6 months' }];
  private _image: any = null;
  private _today: any = new Date();
  private _subscription: Subscription;
  private _paramSubscription: Subscription;
  private _getEntityDetailsSubscription: Subscription;
  private _widgetsSubscription: Subscription;
  private _ActivatedrouteSubscription: Subscription;
  private _statusSubscription :Subscription;
  private _presignedUrlsSubscription: Subscription;

  constructor(private service: EntitiesServiceService,
    public _sharedService: ServicecallService,
    private _Activatedroute: ActivatedRoute,
    private _route: Router,
    private _dataSer: DataService,
    private _imageUrlCacheService: ImageUrlCacheService,
    private _fb: FormBuilder) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh' || res.name === 'deviceMapRefresh' || res.name === 'routePopOverClosed') {
        this._getEntitiesProfile();
      } else if (res.name === 'digitalTwinToggle') {
        this.toggleDigitalTwin = !this.toggleDigitalTwin;
      }
    });
  }

  ngOnInit(): void {
    this._initializeForm();
    const { startDate, endDate } = this._sharedService.getConfiguration('tenantGenericConfig')?.defaultTimeRange
      ? this._sharedService.calculateDateRange(this._sharedService.getConfiguration('tenantGenericConfig')?.defaultTimeRange)
      : { startDate: new Date(this.datePicker?.value.getFullYear(), this.datePicker?.value.getMonth(), this.datePicker?.value.getDate(), 0, 0, 0, 999), 
        endDate: new Date(this.datePicker?.value.getFullYear(), this.datePicker?.value.getMonth(), this.datePicker?.value.getDate(), 23, 59, 59, 999) };

    this.datepickerForm.setValue({
      thisdate: { 
        startDate: this._sharedService.getVehicleDateRange()?.startDate ? new Date(this._sharedService.getVehicleDateRange()?.startDate) : startDate, 
        endDate : this._sharedService.getVehicleDateRange()?.endDate ? new Date(this._sharedService.getVehicleDateRange()?.endDate) : endDate  }
    });
    this.selectedDates.from = this._sharedService.getVehicleDateRange()?.startDate ? new Date(this._sharedService.getVehicleDateRange()?.startDate) : startDate;
    this.selectedDates.to = this._sharedService.getVehicleDateRange()?.endDate ? new Date(this._sharedService.getVehicleDateRange()?.endDate) : endDate;
    this._period.setValue(this._periodList[0]);
    this._ActivatedrouteSubscription = this._Activatedroute.paramMap.subscribe(params => {
      if (params.get('id')) {
        this.entityId = params.get('id');
        this._configurations();
        this._paramSubscription = this._Activatedroute.queryParams
          .subscribe((params: any) => {
            if (Object.keys(params).length) {
              if (params['tenantType'] === 'dover') {
                this.tenantType = 'dover';
                document.getElementById("tab-view").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest"
                });
              }
            }else{
              this._dataSer.broadcast('scrollTop');
            }
          });
      }
    });

  }
  periodFilter(filter: any) {
    this.periodFilterData = filter;
    // if (filter) {
    //   this.onPeriodFilterChange();
    // }
  }

  saveTime(data?: any) {
    if (data) {
      let dateRange: TimePeriod = data;
      const offsetTime = new Date().getTimezoneOffset() * 60 * 1000;
      this.selectedDates.from = this._getTimestampInMillisecond(dateRange?.startDate?.toDate()) + (offsetTime)
      this.selectedDates.to = this._getTimestampInMillisecond(dateRange?.endDate?.toDate()) + (offsetTime);
      this._sharedService.setVehicleDateRange({startDate : this.selectedDates.from, endDate: this.selectedDates.to});
      // this.datepickerForm.setValue({
      //   thisdate: {startDate: this._selectedDates.from, endDate: this._selectedDates.to }
      // });
    } 
  }

  private _getTimestampInMillisecond(date: Date): number {
    return date ? new Date(date)?.getTime() : 0;
  }

  /**
   * Checks point expand
   * @param expand 
   */
  checkPointExpand(expand: boolean) {
    this.expandCheckPointFlag = expand;
  }

  ngOnDestroy(): void {
    if(this._route?.url?.split('/')?.[1] !== 'vehicles') {
      this._sharedService.setFilters({}, 'entity');
      this._sharedService.setSearchKey(null, 'entity');
      this._sharedService.setAlertDtcFilters(false, 'isActiveAlerts');
      this._sharedService.setAlertDtcFilters(false, 'isActiveDTCCases');
    }
    this._subscription?.unsubscribe();
    this._getEntityDetailsSubscription?.unsubscribe();
    this._widgetsSubscription?.unsubscribe();
    this._ActivatedrouteSubscription?.unsubscribe();
    this._paramSubscription.unsubscribe();
    this._statusSubscription?.unsubscribe();
    this._presignedUrlsSubscription?.unsubscribe();

    if (this.toggleDigitalTwin) {
      this._dataSer.broadcast('digitalTwinToggle');
    }
  }

  /**
   * fetches Configurations
   */
  private _configurations() {
    this.attributeThreshold = this._sharedService.getConfiguration('attributeThreshold') ? this._sharedService.getConfiguration('attributeThreshold').threshold : [];
    this.attributeIcons = this._sharedService.getConfiguration('profileAttributeIcons') ? this._sharedService.getConfiguration('profileAttributeIcons').profileAttributeIconList : [];
    this.tenantConfig = this._sharedService.getConfiguration('tenantGenericConfig') ? this._sharedService.getConfiguration('tenantGenericConfig') : null;
    this._getEntitiesProfile();
  }

  /**
   * Gets entities profile
   */
  private _getEntitiesProfile() {
    const entityId = { entityId: this.entityId };
    this._getEntityDetailsSubscription = this.service.getEntityDetails(entityId).subscribe((result: any) => {
      if (result.status) {
        this.masterEntitiesData = result?.response?.data[0];
        this.masterEntitiesData.baseUrl = this.masterEntitiesData?.image;
        this._image = this.masterEntitiesData?.image ? this.masterEntitiesData?.image : null;
        this.siteId = this.masterEntitiesData?.site?._id? this.masterEntitiesData?.site?._id: null;
      } else {
        this._sharedService.toasterService({ type: 'error', msg: result?.response?.message });
      }
      this.parentEntityId = this.entityId;
      this._getWidget();
      this._getStatus();
    });
  }
  private _getStatus(){
    const req= 
      {
        entityIds: [this.entityId] 
      };
    this._statusSubscription = this.service.widgetStatus(req).subscribe({
      next:(result)=>{
        const colorCode = this.tenantConfig?.profile?.find((item: any) => item?.category === this.masterEntitiesData?.category)?.defaultColorCodes;
        if(colorCode){
          if(result[0]?.status === 'Online')
          this.entitiesStatus = {status:result[0]?.status,color:colorCode?.safe};
          else if(result[0]?.status === 'Offline')
          this.entitiesStatus = {status:result[0]?.status,color:colorCode?.unsafe};
          else 
          this.entitiesStatus = {status:result[0]?.status?result[0]?.status:'Not Available',color:colorCode?.default};
        }else{
          this.entitiesStatus = {status:'Not Available',color:'#c7c7c7'};
        }
       

      },error:(result)=>{
        this._sharedService.toasterService({ type: 'error', msg: result?.response?.message });
      }
  });
  }

  /**
   * Gets widget
   */
  private _getWidget() {
    this._widgetsSubscription = this._sharedService.widgets(this._sharedService.getMenuBasedOnUrl(this._route?.url)).subscribe((result: any) => {
      if (result['status']) {
        this.isLoader = false;
        if (result?.response?.data?.length) {
          this.widgetDetails = result.response.data?.map((item: any) => { return { name: item?.name, order: item?.order, attributes: item?.attributes, title: item?.title, dataAttributes: item?.dataAttributes } });
          const profileCategorizationKey = this._sharedService.getConfiguration('tenantGenericConfig')?.profileCategorizationKey ?? 'category';
          const profileConfig = this._sharedService.getConfigurationBasedOnCategory(this.masterEntitiesData) ?
            this._sharedService.getConfigurationBasedOnCategory(this.masterEntitiesData) : [];
          const categoryValue = profileCategorizationKey ? profileCategorizationKey?.split('.')?.reduce((acc, part) => acc?.[part], this.masterEntitiesData) : null;
          let filtedWidget = [];
          if (profileConfig?.widgets?.length) {
            //To display same named chart (common charts) in multiple widgets based on profileCategorizationKey (data.attributes.category)
            if (this._sharedService.getConfiguration('tenantGenericConfig')?.replicableWidgets) { 
              filtedWidget = this.widgetDetails?.filter(item => {
                const categoryMatch = item.attributes?.category
                  ? item.attributes.category === categoryValue
                  : true;
              
                const inProfile = profileConfig?.widgets?.includes(item?.name);
              
                const makeMatch = this.masterEntitiesData?.primaryDetails?.make
                  ? (item.attributes?.make
                      ? item.attributes.make === this.masterEntitiesData.primaryDetails.make
                      : true)
                  : true;
              
                return categoryMatch && inProfile && makeMatch;
              });
            } else {
              //Default condition
              if (!this._hasDuplicates(profileConfig?.widgets)) {
                profileConfig?.widgets.forEach((elem: any) => {
                  const index = this.widgetDetails.findIndex((item: any) => (item?.name === elem));
                  if (index > -1) {
                    filtedWidget.push(this.widgetDetails[index]);
                  }
                })
              }else{
                profileConfig?.widgetsName.forEach((elem: any) => {
                  const index = this.widgetDetails.findIndex((item: any) => (item?.title === elem));
                  if (index > -1) {
                    filtedWidget.push(this.widgetDetails[index]);
                  }
                })
              }
            }
          } else {
            if (this._sharedService.getConfiguration('tenantGenericConfig')?.replicableWidgets) { 
              filtedWidget = this.widgetDetails?.filter(
                item => !item?.attributes || item.attributes.category == null
              );
            } 
          }
          if (filtedWidget?.length) {
            const widgetLimit = this._sharedService.getConfiguration('tenantGenericConfig')?.profileWidgetLimit ?? 4;
            this.widgetDetails = [...filtedWidget]?.sort((a: any,b :any)=> a?.order - b?.order)?.slice(0,widgetLimit);
          } else if(this._sharedService.getConfiguration('tenantGenericConfig')?.replicableWidgets && !filtedWidget?.length){
            this.widgetDetails = [];
          }
        } else {
          this.widgetDetails = [];
        }
      }
      else {
        this.isLoader = false;
        this.widgetDetails = [];
        this._sharedService.toasterService({ type: 'error', msg: result?.response?.message });
      }
    });
  }

  /**
   * Gets value by path
   * @param obj 
   * @param path 
   * @returns  
   */
  getValueByPath(obj: any, path: string) {
    return path?.split('.')?.reduce((acc, part) => acc?.[part], obj);
  }

  /**
   * Determines whether duplicates are present
   * @param array 
   * @returns  
   */
  private _hasDuplicates(array) {
    return new Set(array).size !== array.length;
  }

  get scalingClass(): string {
    const scale = this._sharedService.getScalingFactor();
    return `dp${scale}`;
  }

}

